export default "__VITE_ASSET__Ccl35caN__"